import WarningIcon from '@material-ui/icons/Warning';

import { useStyles } from './style';

const MissingRecipientsNotification = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <WarningIcon className={classes.warningIcon} />
      <p className={classes.description}>
        Viestille ei ole valittu vastaanottajia. Tarkista lähetystapa- ja
        vastaanottajavalinnat.
      </p>
    </div>
  );
};

export default MissingRecipientsNotification;
